import { router } from '../router'

export const getNoRequiresAuthURL = () => {
  const routes = router.getRoutes()
  return routes
    .filter((route) => {
      return !route.meta.requiresAuth && route.name !== undefined
    })
    .map((route) => {
      return route.name
    })
}

export const checkNoRequiresAuthURL = (routeName: string) => {
  const noRequiresAuthURL = getNoRequiresAuthURL()
  return noRequiresAuthURL.includes(routeName)
}
